import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { ManagedPortfolioType } from "./ManagedPortfolioService";
import { TRatiosCarterasDBModel } from "../screen/Portfolios/File/types/CarteraRatioTypes";
import { TDiversCartMaxLevelDetailModel, TDiversCartMiniTable, TDiversCartTipoActivo1RiesgoModel, TDiversCartTipoActivo1y2RiesgoModel, TDiversCartTotalInferiorModel, TDiversCartTotalTipoActivo1Model, TDiversCartTotalTipoActivo1y2Model, TDiversificationScreen } from "../screen/Portfolios/File/types/DiversificacionCarteraTypes";
import { TPrincipalPositions } from "../screen/Portfolios/File/types/PrincipalPositionTypes";
import { TIndicesYModelosDBModel, TRatiosIndicesDBModel } from "../screen/Portfolios/File/types/IndicesTypes";
setupInterceptorsTo(axios);

interface IFinametrixContraccType
{
    id?: number,
    finametrixId?: string,
    name?: string
}
interface IFnmContract
{
    id?: number,
    completed: boolean,
    finametrixContractId?: string,
    finametrixContract?: string,
    finametrixContraccType?: IFinametrixContraccType,
    createdAt?: string,
    updatedAt?: string
}
interface IPortfolio
{
    id?: number,
    finametrixId?: string,
    fnmContract: IFnmContract,
    managedPortfolio: ManagedPortfolioType,
    createdAt?: string,
    updatedAt?: string
}
export type PortfolioType = IPortfolio
export type FnmContractType = IFnmContract

class PortfolioService
{
    public getPortfolio = async (portfolioId: number): Promise<PortfolioType> =>
    {
        let url: string = `${proxyUrl}/fnmportfolios/${portfolioId}`
        const req = await axios.get<any>(url)
        return req.data
    }
    public createPortfolio = async (portfolio: PortfolioType): Promise<PortfolioType> =>
    {
        let url: string = `${proxyUrl}/fnmportfolios`
        const req = await axios.post(url, portfolio)
        return req.data
    }
    public getPortfoliosByUserIdentityId = async (userIdentityId: number): Promise<PortfolioType[]> =>
    {
        let url: string = `${proxyUrl}/fnmportfolios/getByUserIdentityId/${userIdentityId}`
        const req = await axios.get(url)
        return req.data
    }
    public getRatioCarteraByNomcontrato = async (nomcontrato: string): Promise<TRatiosCarterasDBModel[]> => {
        let url: string = `${proxyUrl}/ratioscarteras/getByNomcontrato/${nomcontrato}`
        const req = await axios.get(url)
        return req.data
    }
    public getPrincipalPositions = async (isinList: string[]): Promise<TPrincipalPositions[]> => {
        let url: string = `${proxyUrl}/principalpositions/getPositions`;
        const req = await axios.post(url, isinList, { headers: { "content-type": "application/json" } });
        return req.data;
    }
    public getRatioCarteraByRatioAndPeriodAndNomcontrato = async ({ratio, period, nomcontrato} : {ratio: string, period: string, nomcontrato: string}): Promise<TRatiosCarterasDBModel[]> => {
        let url: string = `${proxyUrl}/ratioscarteras/getByRatioAndPeriodAndNomcontrato/${ratio}/${period}/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetTipoActivo1Riesgo = async (nomcontrato: string): Promise<TDiversCartTipoActivo1RiesgoModel[]> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetTipoActivo1Riesgo/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetTipoActivo1y2Riesgo = async (nomcontrato: string): Promise<TDiversCartTipoActivo1y2RiesgoModel[]> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetTipoActivo1y2Riesgo/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetTotalInferior = async (nomcontrato: string): Promise<TDiversCartTotalInferiorModel> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetTotalInferior/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetTotalTipoActivo1 = async (nomcontrato: string): Promise<TDiversCartTotalTipoActivo1Model[]> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetTotalTipoActivo1/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetTotalTipoActivo1y2 = async (nomcontrato: string): Promise<TDiversCartTotalTipoActivo1y2Model[]> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetTotalTipoActivo1y2/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetDescCartMaxLevelDetail = async (nomcontrato: string): Promise<TDiversCartMaxLevelDetailModel[]> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetDescCartMaxLevelDetail/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetDescCartMiniTable = async (nomcontrato: string): Promise<TDiversCartMiniTable> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetDescCartMiniTable/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetDiversificationScreen = async (nomcontrato: string): Promise<TDiversificationScreen> => {
        let url: string = `${proxyUrl}/diversificacioncarteras/GetDiversificationScreen/${nomcontrato}`;
        const req = await axios.get(url);
        return req.data;
    }
    public GetAllIndicesYModelos = async (): Promise<TIndicesYModelosDBModel[]> => {
        let url: string = `${proxyUrl}/omniaServices/GetAllIndices/`
        const req = await axios.get(url)
        return req.data
    }
    public GetRatiosIndicesByFinametrixId = async (finametrixId: string): Promise<TRatiosIndicesDBModel[]> => {
        let url: string = `${proxyUrl}/omniaServices/GetRatiosIndicesByFinametrixId/${finametrixId}`
        const req = await axios.get(url)
        return req.data
    }
    public GetRatiosIndicesByFinametrixIdRatioPeriod = async ({ratio, period, finametrixId} : {
        ratio: string,
        period: string,
        finametrixId: string}
    ): Promise<TRatiosIndicesDBModel[]> => {
        let url: string = `${proxyUrl}/omniaServices/GetRatiosIndicesByFinametrixIdRatioPeriod/${finametrixId}/${ratio}/${period}`
        const req = await axios.get(url)
        return req.data
    }
}

const portfolios = new PortfolioService();
export default portfolios;